import styled, { css, DefaultTheme } from 'styled-components';

export const SignInContainer = styled.div`
  ${({ theme: { colors } }): DefaultTheme => {
    return css`
      background: ${colors['page-bg-colour-primary']};
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
    `;
  }}
`;

export const LoginContainer = styled.div`
  ${({ theme: { floats, colors } }): DefaultTheme => {
    return css`
      background: ${colors['content-container-bg-colour-full']};
      width: 438px;
      height: 407px;
      border-radius: ${floats['corner-radius-medium']};
      padding: ${floats['padding-3xlarge']};
    `;
  }}
`;

export const SelectCountryText = styled.div`
  display: flex;
  text-align: center;
`;

export const BrandLogo = styled.div`
  ${({ theme: { floats } }): DefaultTheme => {
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: ${floats['margin-large']};
    `;
  }}
`;

export const DescriptionText = styled.div`
  ${({ theme: { floats } }): DefaultTheme => {
    return css`
      display: flex;
      text-align: center;
      margin-top: ${floats['margin-large']};
    `;
  }}
`;

export const CountryLabel = styled.div`
  ${({ theme: { floats } }): DefaultTheme => {
    return css`
      margin-top: ${floats['margin-large']};
    `;
  }}
`;

export const LoginButton = styled.div`
  ${({ theme: { floats } }): DefaultTheme => {
    return css`
      margin-top: ${floats['margin-large']};
    `;
  }}
`;
